import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Container, Input, Label, Row } from 'reactstrap';
import { toast } from "react-toastify";
import { ServiceThreadSpinner } from '.';
import { api } from '../utils';

export default function ManageTwistDefaults() {
   const [model, setDefaults] = useState({});
   const [spin, setSpinner] = useState(true);
   const disabled = JSON.stringify(model) === "{}";

   useEffect(() => {
      GetTwistDefaults();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   function GetTwistDefaults() {
      setSpinner(true);
      api
         .fetch(`Engineering/GetTwistDefaults`)
         .then((response) => {
            if (response?.data) {
               if (response.data.success) {
                  setDefaults(response.data.defaults);
               } else {
                  toast.error(response.data.message);
               }
            }
            else {
               toast.error("Unable to retrieve default values!");
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setSpinner(false);
         });
   }

   const handleFocus = (event) => event.target.select();

   function onChange(field, value) {
      if (field === "baseYarn" && value > 99999) {
         toast.warn("Base yarn cannot exceed 5 digits");
         return;
      }
      if (field === "ply" && value > 99) {
         toast.warn("Ply cannot exceed 2 digits");
         return;
      }
      if (field === "tpm" && value > 250) {
         toast.warn("TPM cannot exceed 250");
         return;
      }
      if (field === "tpi" && value > 8) {
         toast.warn("TPI cannot exceed 8");
         return;
      }
      if (field === "spindles" && value > 999) {
         toast.warn("Spindles cannot exceed 3 digits");
         return;
      }

      let changes = Object.assign({}, model);
      changes[field] = value;
      setDefaults(changes);
   }

   function SaveDefaults() {
      if (disabled) {
         toast.error("Missing Defaults!");
         return;
      }

      if (model?.baseYarn < 1) {
         toast.warn("Base yarn is required");
         return;
      }
      if (model?.ply < 1) {
         toast.warn("Ply is required");
         return;
      }
      if (model?.tpm < 20 || model?.tpm > 250) {
         toast.warn("TPM is required and must be between 20 and 250");
         return;
      }
      if (model?.tpi < 1 || model?.tpi > 8) {
         toast.warn("TPI is required and must be between 1 and 8");
         return;
      }
      if (model?.efficiency <= 0) {
         toast.warn("Efficiency is required");
         return;
      }
      if (model?.efficiency > 1) {
         toast.warn("Efficiency cannot exceed 100%");
         return;
      }
      if (model?.spindles < 1) {
         toast.warn("Number of spindles is required");
         return;
      }
      if (model?.twistContraction < 0.01 || model?.twistContraction > 0.05) {
         toast.warn("Twist Contraction is required and must be between 1% and 5%");
         return;
      }

      setSpinner(true);
      api.post(`Engineering/SaveTwistDefaults`, model)
         .then((response) => {
            if (response.data.success) {
               toast.success("Twister calculation defaults updated!")
            } else {
               toast.error(response.data.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinner(false);
         })
         .finally(() => {
            setSpinner(false);
         });
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <ServiceThreadSpinner on={spin}>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           <Label className="noWrap h5">Change one or more default values below and click the Save Defaults button</Label>
                           <br /><br />
                           <div>
                              <Row>
                                 <Col className="data-cell noWrap h6 width150px">Base Yarn (Dn):</Col>
                                 <Col className="data-cell noWrap h6 width135px">
                                    <Input
                                       type="number"
                                       name="baseYarn"
                                       value={model?.baseYarn || "0"}
                                       className="h-100 py-1 no-spinner"
                                       onChange={(e) => { onChange("baseYarn", e.target.value) }}
                                       maxLength={5}
                                       max={99999}
                                       min={1}
                                       onFocus={handleFocus}
                                    />
                                 </Col>
                                 <Col className="data-cell noWrap h6 width40px"></Col>
                                 <Col className="data-cell noWrap h6 width95px">Ply:</Col>
                                 <Col className="data-cell noWrap h6 width95px">
                                    <Input
                                       type="number"
                                       name="ply"
                                       value={model?.ply || "0"}
                                       className="h-100 py-1 no-spinner"
                                       onChange={(e) => { onChange("ply", e.target.value) }}
                                       maxLength={2}
                                       max={99}
                                       min={1}
                                       onFocus={handleFocus}
                                    />
                                 </Col>
                                 <Col className="data-cell noWrap h6 width40px"></Col>
                                 <Col className="data-cell noWrap h6 width135px">Twist (TPI):</Col>
                                 <Col className="data-cell noWrap h6 width135px">
                                    <Input
                                       type="number"
                                       name="tpi"
                                       value={model?.tpi || "0"}
                                       className="h-100 py-1 no-spinner"
                                       onChange={(e) => { onChange("tpi", e.target.value) }}
                                       maxLength={4}
                                       max={8.00}
                                       min={1.00}
                                       onFocus={handleFocus}
                                    />
                                 </Col>
                                 <Col className="data-cell noWrap h6 width40px"></Col>
                              </Row>

                              <Row>
                                 <Col className="data-cell noWrap h6 width150px">Twist Contraction:</Col>
                                 <Col className="data-cell noWrap h6 width135px">
                                    <Input
                                       type="number"
                                       name="twistContraction"
                                       value={model?.twistContraction || "0"}
                                       className="h-100 py-1 no-spinner"
                                       onChange={(e) => { onChange("twistContraction", e.target.value) }}
                                       maxLength={5}
                                       max={0.05}
                                       min={0.01}
                                       onFocus={handleFocus}
                                    />
                                 </Col>
                                 <Col className="data-cell noWrap h6 width40px"></Col>
                                 <Col className="data-cell noWrap h6 width95px">Spindles:</Col>
                                 <Col className="data-cell noWrap h6 width95px">
                                    <Input
                                       type="number"
                                       name="spindles"
                                       value={model?.spindles || "0"}
                                       className="h-100 py-1 no-spinner"
                                       onChange={(e) => { onChange("spindles", e.target.value) }}
                                       maxLength={3}
                                       max={999}
                                       min={1}
                                       onFocus={handleFocus}
                                    />
                                 </Col>
                                 <Col className="data-cell noWrap h6 width40px"></Col>
                                 <Col className="data-cell noWrap h6 width135px">Efficiency:</Col>
                                 <Col className="data-cell noWrap h6 width135px">
                                    <Input
                                       type="number"
                                       name="efficiency"
                                       value={model?.efficiency || "0"}
                                       className="h-100 py-1 no-spinner"
                                       onChange={(e) => { onChange("efficiency", e.target.value) }}
                                       maxLength={4}
                                       max={1.00}
                                       min={0.10}
                                       onFocus={handleFocus}
                                    />
                                 </Col>
                              </Row>
                              <Col className="data-cell noWrap h6 width40px"></Col>
                           </div>
                        </Col>
                     </Row>
                     <br />
                     <Button title="Save"
                        className="shredButtonExcel ms-2"
                        onClick={() => SaveDefaults()}
                        disabled={disabled}>
                        Save Defaults
                     </Button>
                     <br />
                  </ServiceThreadSpinner>
               </Fragment>
            </Col>
         </Row>
      </Container>
   );
}
